import { IFirmlyApproved } from './../../../shared/interfaces/firmly-approved';
import { SpecialOfferModel } from './../../../shared/models/specialOffer/special-offer.model';
import { FirmlyApprovedService } from './../../../shared/services/firmly-approved/firmly-approved.service';
import { IPopupState } from './../../../shared/interfaces/popup.interface';
import { PopupService } from './../../../shared/services/popup/popup.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { ProductsService } from 'src/app/shared/services/products/products.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { TagEvent } from 'src/app/shared/models/dali-tags.model';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
// import { DataAbrecuenta } from './data-mock';

const LOAN_PRODUCT = 'loan';
@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss'],
})
export class RequestComponent implements OnInit {
  phase: any[];
  formGroup: FormGroup;
  list_multi: any[] = [];
  showLoanRequest: boolean;
  statusValidation = false;
  checkboxValidation = false;
  select_products: any[] = [];
  array: any[] = [];
  product: any = {};
  loan = false;
  beNormalized: boolean;
  personal = false;
  cardCredit = false;
  rotary = false;
  resListChecked: any[] = [];
  jsonResProduct: any[] = [];
  productsSelectedMulti: any;
  solicitationId;
  code;
  isMonoLoan: boolean;
  multi: any[];
  haveLoan: boolean;
  channelId;
  firmlyApprovedOffers: IFirmlyApproved[];
  hasFirmlyApprovedOffer: boolean;

  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private bitacoraService: BitacoraService,
    private formBuilder: FormBuilder,
    private parameterService: ParametersService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private productsService: ProductsService,
    private bioCatchService: BioCatchService,
    private taggingService: TaggingService,
    private requestService: RequestService,
    private captureService: CaptureService,
    private postValidate: PostValidateService,
    private identificationService: IdentificationService,
    private validationHelperService: ValidationHelperService,
    private productLoaderService: ProductLoaderService,
    public channelCommunicatorService: ChannelCommunicatorService,
    private popupService: PopupService,
    private firmlyApprovedService: FirmlyApprovedService,
  ) {
    this.headerService.show(true, true, true);
    this.channelId = this.channelCommunicatorService.getChannelId();
  }

  async ngOnInit() {
    this.sendTagging('init');
    this.list_multi = this.parameterService.getSetting(OpEnum.LIST_MULTI);
    if (
      this.channelCommunicatorService.getChannelId() !== CHANNEL.PORTALO.CODE
    ) {
      this.list_multi.map(m => {
        if (m.flow === 'loan') {
          m.show = false;
        }
      });
    }
    if (this.abreCuentasService.getUserJemelii()) {
      console.log(this.list_multi);
      this.list_multi.map(m => {
        if (m.flow === 'revolvingCredit' ||
          m.flow === 'freeInvestment' ||
          m.value === 'Créditos') {
          m.show = false;
        }
      });
    }
    let products = this.abreCuentasService.getPostlogin()
      ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
      : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
    this.multi = products;
    this.initForm();

    // VALIDACION SI EXISTEN PRODUCTOS YA SELECCIONADOS
    if (this.abreCuentasService.getProductsSelects().length > 0) {
      for (let row of this.abreCuentasService.getProductsSelects()) {
        if (row.status) {
          this.formGroup.patchValue({
            [row.flow]: row.status,
          });
        }
      }
    }

    await this.validateFirmlyApprovedOffersForPopup();

    if (this.hasFirmlyApprovedOffer) {
      this.popupService.showPopup();
    }
  }

  initForm() {
    this.formGroup = this.formBuilder.group(this.createForm());
    this.formGroup.valueChanges.subscribe(res => {
      this.validData(res);
    });
  }

  async validateFirmlyApprovedOffersForPopup() {
    const channelsAllowed = [
      CHANNEL.PORTALPN.CODE,
      CHANNEL.SUPERAPP.CODE,
    ];
    if (!this.abreCuentasService.getPostlogin() || !channelsAllowed.includes(this.channelId)) {
      return;
    }
    await this.firmlyApprovedService.getProductsOffer();
    this.firmlyApprovedOffers = this.firmlyApprovedService.getProductsFirmlyApproved();
    if (this.firmlyApprovedOffers && this.firmlyApprovedOffers.length > 0) {
      let offerData: SpecialOfferModel = {
        offerId: String(this.firmlyApprovedOffers[0].id),
        offerType: this.firmlyApprovedOffers[0].offerType,
      };
      console.warn('firmlyApproved offerData:', offerData);
      this.firmlyApprovedService.setOffer_Channel(offerData);
      this.hasFirmlyApprovedOffer = true;
    }
  }

  /**
   * Se retira metodo ya que en la linea 125 a la 129 hace la misma función
   */

  // checkChecked() {
  //   if (this.formGroup.controls['freeInvestment'].value) {
  //     this.loan = true;
  //     this.formGroup.controls['loan'].disable();
  //   } else {
  //     this.formGroup.controls['loan'].enable();
  //   }

  //   if (this.formGroup.controls['loan'].value) {
  //     this.loan = true;
  //     this.formGroup.controls['freeInvestment'].disable();
  //   } else {
  //     this.formGroup.controls['freeInvestment'].enable();
  //   }

  // }

  opacityChange(clas: string) {
    if (clas === 'loan' && this.formGroup.controls['freeInvestment'].value) {
      return 'loan';
    }
    if (clas === 'freeInvestment' && this.formGroup.controls['loan'].value) {
      return 'freeInvestment';
    }
  }
  validData(data: any) {
    this.array = [];
    this.statusValidation = false;

    for (let row in data) {
      let object = this.list_multi
        .filter(item => item.flow)
        .filter(item => item.flow === row)[0];
      if (data[row]) {
        object.status = data[row];
        this.array.push(object);
        this.statusValidation = true;
      }
    }

    // validation loan
    if (
      (data.loan || data.freeInvestment) &&
      this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE
    ) {
      this.loan = true;
    } else if (!data.loan && !data.freeInvestment) {
      this.loan = false;
    }

    if (data.freeInvestment) {
      this.personal = true;
    } else {
      this.personal = false;
    }
    // Validation +3 checkbox

    if (this.array.length === 3) {
      this.checkboxValidation = true;
    } else {
      this.checkboxValidation = false;
    }
  }

  async next() {
    this.beNormalized = false;
    this.haveLoan =
      this.array.filter(product => product.flow === LOAN_PRODUCT).length > 0;
    this.abreCuentasService.setHaveloan(this.haveLoan);
    this.abreCuentasService.setProductsSelects(this.array);
    this.abreCuentasService.setFlowStructure(
      this.abreCuentasService.getAbreCuentasModel().flowStructure,
    );
    await this.validategetAgreementsOffersLoan();
    console.log('ARRAY---', this.array);
    if (this.array.length > 1) {
      this.viewMulti();
      this.multi = this.multi.filter(
        (product: any) => product.product_type === 'multi',
      );
      this.abreCuentasService.setproductSelected(this.multi[0]);
      if (
        this.abreCuentasService.getPostlogin() &&
        this.abreCuentasService.getproductSelected().product_type ===
        BUSINESS_CONST.MULTI
      ) {
        await this.callClientExistInformationService();
      } else {
        this.navigateLoanProduct();
      }
    } else if (this.array.length === 1) {
      this.array[0].prioritize = '1';
      this.array[0].prioritizeForClient = '1';
      this.abreCuentasService.setProductsSelects(this.array);
      this.abreCuentasService.setMultiView(false);
      let products = this.abreCuentasService.getPostlogin()
        ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
        : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
      this.product = products.filter(fil => fil.flow === this.array[0].flow)[0];
      this.abreCuentasService.setproductSelected(this.product);
      if (this.abreCuentasService.getPostlogin()) {
        await this.callClientExistInformationService(this.array[0].code);
      } else if (
        this.array[0].product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN &&
        !this.beNormalized
      ) {
        this.navigationService.nextStep('203');
      } else {
        this.navigationService.nextStep(this.array[0].code);
      }
    }
    const sendExtras = {
      object: 'transactionProductDetails',
      value: this.addProductExtra(),
      pageValue: 'request',
    };
    this.sendTagging('next', 'bottom', '3', sendExtras);
    this.saveBitacoraProducts();
  }

  sendTagging(value: any, position?: string, event?: string, extras?: any) {
    const page = '25';
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }

  addProductExtra() {
    let extras = '';
    const extrasProduct = {
      TCR : () => 'TarjetaCredito',
      ORD : () => 'CreditoPersonal',
      CRP : () => 'CreditoRotativo',
    };
    this.array.forEach((product, index) => {
      extras += extrasProduct[product.product_code]();
      if (index < (this.array.length - 1)) {
        extras += ',';
      }
    });
    console.log('Extras Taggeo: ', extras);
    return extras;
  }

  saveBitacoraProducts() {
    this.array.forEach(element => {
      this.bitacoraService.saveDataInBitacora(element.product_type);
    });
  }

  navigateLoanProduct() {
    switch (this.haveLoan) {
      case true:
        this.navigationService.nextStep('202');
        break;
      default:
        this.navigationService.nextStep('200');
        break;
    }
  }

  async validategetAgreementsOffersLoan() {
    let loanFilter = this.array.filter(item => item.flow === 'loan');
    if (loanFilter.length > 0) {
      // return true;
      await this.productsService
        .getAgreementsOffersLoan()
        .then(data => {
          console.log(data);
          return true;
        })
        .catch(error => console.log(error));
    } else {
      return false;
    }
  }

  viewMulti() {
    this.abreCuentasService.setMultiView(true);
  }

  closeApp() {
    const bitacoraEvent = `exit_process`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    this.navigationService.loadExitScreen = true;
  }

  createForm() {
    let values: any = {};
    for (let field of this.list_multi) {
      if (field.flow) {
        values[field.flow] = [''];
        values[field.flow].push(Validators.required);
      }
    }
    return values;
  }

  /*
   * Función para ir a los detalles del producto seleccionado
   *
   * *Go to selected product details function*
   *
   * @param {IProductsModel} product
   * @param {string} _label
   */
  goToProductDetails(productFlow: string, _label: string) {
    this.abreCuentasService.setProductsSelects(this.array);
    let products = this.abreCuentasService.getPostlogin()
      ? this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS_CE)
      : this.parameterService.getSetting(OpEnum.ABRE_CUENTAS_PRODUCTS);
    this.product = products.filter(fil => fil.flow === productFlow)[0];
    this.selectProduct(this.product, 'nextToProductDetails');
    const category = {
      module: 'body',
      type: 'link',
      position: 'bottom',
    };
    const productCamelize = this.navigationService.camelize(this.product.name);
    const CustomLabel = `${_label} | ${productCamelize}`;
    this.pageTagEvent('1', category, 'click', CustomLabel);
  }

  /**
   * Función que guarda la información del producto seleccionado
   *
   * *Funtion that saves selected product infomation*
   *
   * @param {IProductsModel} product
   * @param {string} advance
   */
  selectProduct(product: IProductsModel, advance: string) {
    this.productsService
      .assignProductType(product)
      .then(() => {
        const biocatchInfo: any = this.bioCatchService.getBiocatchInfo();
        this.abreCuentasService.setproductSelected(product);
        if (this.abreCuentasService.getIsPortal()) {
          this.bitacoraService.saveDataInBitacora('Chanel_131_Portal');
        }
        this.bitacoraService.saveDataInBitacora(product.product_type);
        if (!!biocatchInfo.ipGeoCity && !!biocatchInfo.ipGeoCountry) {
          const bitacoraEvent = `geo_biocatch_${biocatchInfo.ipGeoCity}_${biocatchInfo.ipGeoCountry}`;
          this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        }
        this[advance.toString()]();
      })
      .catch(() => this.navigationService.navigateToGeneralInformation('500'));
  }

  pageTagEvent(
    eventNumber: string,
    category: any,
    customAction: string,
    customLabel?: string,
  ) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    const event: TagEvent = {
      category: {
        module: EVENT.customCategory.module[category.module],
        type: EVENT.customCategory.type[category.type],
        position: EVENT.customCategory.position[category.position],
      },
      action: EVENT.customAction[customAction],
      label: customLabel
        ? customLabel
        : EVENT[`${tagPageName}E${eventNumber}customLabel`],
    };

    this.taggingService.pageTagEvent(event);
  }

  /*
   * Función para ir a los detalles del producto seleccionado, se utiliza el código del producto
   *
   * Function that goes to the selected product details, it uses the product code
   */
  nextToProductDetails() {
    switch (this.product.code) {
      case '205':
        this.navigationService.nextStep('951');
        break;
      default:
        this.navigationService.nextStep('952');
        break;
    }
  }

  async callPerformPco() {
    this.productLoaderService.show(this.copyService.copies.show_load_pco);
    await this.captureService
      .performIncomes()
      .then(async (income: any) => {
        if (income !== '200') {
          this.navigationService.navigateToGeneralInformation('107');
          return;
        }
        await this.captureService
          .performPco()
          .then(async (res: any) => {
            if (res !== '200') {
              this.navigationService.navigateToGeneralInformation('107');
              return;
            }
            await this.abreCuentasService.sleep(50000);
            await this.captureService
              .getChannelComunicator()
              .then(async (code: any) => {
                if (
                  code === '107' ||
                  code === '121' ||
                  code === '130' ||
                  code === '129' ||
                  code === '124' ||
                  code === '127'
                ) {
                  this.navigationService.navigateToGeneralInformation(code);
                } else {
                  if (code === '17') {
                    this.beNormalized = true;
                    if (this.abreCuentasService.viewOptionMultiProduct) {
                      this.loanProductFilter();
                    } else {
                      this.navigationService.navigateToGeneralInformation(
                        'LIBERROR',
                      );
                      this.bitacoraService.saveDataInBitacora(
                        'Normalization_yes',
                      );
                    }
                  }
                }
                this.productLoaderService.hide();
              })
              .catch(() =>
                this.navigationService.navigateToGeneralInformation('107'),
              );
          })
          .catch(() =>
            this.navigationService.navigateToGeneralInformation('107'),
          );
      })
      .catch(() => this.navigationService.navigateToGeneralInformation('107'));
  }

  loanProductFilter() {
    this.productsSelectedMulti.forEach(products => {
      if (products.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
        // tslint:disable-next-line: no-shadowed-variable
        this.array = this.productsSelectedMulti.filter(products => {
          return products.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LOAN;
        });
        this.abreCuentasService.setProductsSelects(this.array);
      }
    });
  }

  async callClientExistInformationService(code?: any) {
    const documentInfo = this.abreCuentasService.getDocumentInfo();
    /*const parms = {
      issusedIdentType: documentInfo.document_type,
      issusedIdentValue: documentInfo.document_number,
    };*/
    const parms = {
      data: {
        document: {
          number: documentInfo.document_number,
          type: documentInfo.document_type,
        },
      },
    };
    await this.identificationService
      .getClientInformation(parms)
      .then(async (resp: any) => {
        if (resp.status === 200) {
          this.abreCuentasService.setCustomerData(resp.body.data);
          this.validationHelperService.setCustomerDataClient();
          if (this.haveLoan) {
            await this.callPerformPco();
            this.navigationService.nextStep('202');
          } else if (this.abreCuentasService.viewOptionMultiProduct) {
            this.navigationService.nextStep('200');
          } else {
            this.navigationService.nextStep(code);
          }
        }
        return;
      })
      .catch(() => this.navigationService.navigateToGeneralInformation('512'));
  }
}
